import React, { FC, ReactElement, ReactNode } from 'react';

import { Grid, Stack, Typography } from '@mui/material';
import { DiscordLogo, MediumLogo, TwitterLogo } from 'phosphor-react';

import { NormalDivider } from '~components/shared/divider';
import { NormalLink } from '~components/shared/link';
import { primaryColors, white } from '~components/theme/styles/colors';

const FooterLink: FC<{ title: string; href: string; icon?: ReactElement }> = ({ href, title, icon }) => {
  return (
    <NormalLink href={href} sx={{ textDecoration: 'none' }}>
      <Stack direction={'row'} spacing={2} alignItems={'center'}>
        {icon ? icon : null}
        <Typography
          variant="body3"
          color={primaryColors[700]}
          sx={{ transition: 'color 0.15s linear', ': hover': { color: primaryColors[400] } }}
        >
          {title}
        </Typography>
      </Stack>
    </NormalLink>
  );
};

const FooterLinkList: FC<{ title: string; children: ReactNode }> = ({ title, children }) => {
  return (
    <Stack spacing={3} textAlign={'left'} mt={8}>
      <Typography mb={1} variant={'base'}>
        {title}
      </Typography>
      {children}
    </Stack>
  );
};

const LandingFooter = () => {
  return (
    <Stack
      justifyContent={'center'}
      alignItems={'center'}
      width={'100%'}
      mb={2}
      sx={{ px: { xs: '32px', md: '144px' } }}
    >
      <Grid container justifyContent={'center'} textAlign={'center'}>
        <Grid item xs={6} md={2}>
          <FooterLinkList title={'About'}>
            <FooterLink title={'About Vesta'} href={''} />
            <FooterLink title={'Trust & Transparency'} href={''} />
            <FooterLink title={'Roadmap'} href={''} />
          </FooterLinkList>
        </Grid>
        <Grid item xs={6} md={2}>
          <FooterLinkList title={'Learn'}>
            <FooterLink title={'Vesta Stable'} href={''} />
            <FooterLink title={'Tutorial'} href={''} />
          </FooterLinkList>
        </Grid>
        <Grid item xs={6} md={2}>
          <FooterLinkList title={'Governance'}>
            <FooterLink title={'Curia Forum'} href={''} />
            <FooterLink title={'Vote on Snapshot'} href={''} />
          </FooterLinkList>
        </Grid>
        <Grid item xs={6} md={2}>
          <FooterLinkList title={'Developers'}>
            <FooterLink title={'Documentation'} href={'https://docs.vestafinance.xyz/'} />
            <FooterLink title={'Github'} href={''} />
          </FooterLinkList>
        </Grid>
        <Grid item xs={6} md={2}>
          <FooterLinkList title={'Join Us'}>
            <FooterLink
              title={'Careers'}
              href={
                'https://vesta-finance.notion.site/Open-Roles-on-the-Core-Team-40ce0831db6642b28bdc94d3521372a9'
              }
            />
          </FooterLinkList>
        </Grid>
        <Grid item xs={6} md={2}>
          <FooterLinkList title={'Community'}>
            <FooterLink title={'Twitter'} icon={<TwitterLogo />} href={'https://twitter.com/vestafinance'} />
            <FooterLink title={'Medium'} icon={<MediumLogo />} href={'https://medium.com/@VestaFinance'} />
            <FooterLink title={'Discord'} icon={<DiscordLogo />} href={'https://discord.gg/yKsr6PRtxK'} />
          </FooterLinkList>
        </Grid>

        <Stack mt={4} width={'100%'}>
          <NormalDivider />
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            mb={4}
            mt={4}
            justifyContent={'center'}
            alignItems={'center'}
          >
            <Stack direction={'row'} spacing={4} justifyContent={'start'} width={'100%'}>
              {' '}
              <Typography variant="label3" color={primaryColors[700]}>
                PROUD CREATION OF MAXIMUS LABS
              </Typography>
              <NormalLink
                sx={{ textDecoration: 'none' }}
                href={
                  'https://docs.google.com/document/d/e/2PACX-1vR35fS4nqisK3TMMmULwrZBqRu-ujqShbrZU_3KeqU51yGWe_lQtqCFAoIC1Lg5f67n4mDKYbsbZ093/pub'
                }
              >
                <Typography
                  sx={{ transition: 'color 0.15s linear', ': hover': { color: primaryColors[400] } }}
                  variant="label3"
                  color={primaryColors[900]}
                >
                  TERMS OF SERVICE
                </Typography>
              </NormalLink>
              <NormalLink
                href={
                  'https://docs.google.com/document/d/e/2PACX-1vRAewaErhuxxT6Hxss_3IWNVw3-PlByipiDIXYwNhfVF0EDEp0CGbBPSjSzN9JHbmafM5BtU0KOf0w0/pub'
                }
                sx={{ textDecoration: 'none' }}
              >
                <Typography
                  sx={{ transition: 'color 0.15s linear', ': hover': { color: primaryColors[400] } }}
                  variant="label3"
                  color={primaryColors[900]}
                >
                  PRIVACY POLICY
                </Typography>
              </NormalLink>
            </Stack>
            <Typography
              variant="h6"
              sx={{
                color: white['15%'],
                display: 'flex',
                gap: '1em',
                justifyContent: 'space-around',
                textAlign: 'center',
                mt: { xs: 4, sm: 0 },
              }}
            >
              <span>V</span>
              <span>E</span>
              <span>S</span>
              <span>T</span>
              <span>A</span>
            </Typography>
          </Stack>
        </Stack>
      </Grid>
    </Stack>
  );
};

export default LandingFooter;
